<template>
  <a-modal
    :title="audit ? '评审费审批' : '评审费详情'"
    class="gufiiguy"
    :visible="is_show"
    style="top: 20px"
    :width="1200"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="is_show = false"
  >
    <template slot="footer">
      <a-button type="primary" @click="downloadData" style="float: left"> 导出 </a-button>
      <a-button key="back" @click="is_show = false"> 取消 </a-button>
      <a-button type="danger" @click="reject(3)" v-if="audit"> 驳回 </a-button>
      <a-button key="submit" type="primary" @click="reject(1)" v-if="audit"> 转交 </a-button>
      <a-button key="submit" type="primary" @click="reject(2)" v-if="audit"> 通过 </a-button>
    </template>
    <div ref="sadsada">
      <a-form :form="form" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <div class="title">
          <span>基本信息</span>
        </div>
        <div class="content">
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批标题"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.title }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                label="审批编号"
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span>{{ mdl.reviewCode }}</span>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                label="抄 送 人 "
                class="model_span_form"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 21 }"
              >
                <span class="spanClass">{{ mdl.ccName }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="隶属公司">
                <span class="spanClass">{{ mdl.companyName }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="隶属部门">
                <span class="spanClass">{{ mdl.deptName }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="付款方式">
                <span class="spanClass">{{ paymentMap[mdl.paymentMode] }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="支付日期">
                <span class="spanClass">{{ mdl.paymentDate }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="支付对象">
                <span class="spanClass">{{ mdl.paymentObject }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="开户行">
                <span class="spanClass">{{ mdl.bankOfDeposit }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="银行账户">
                <span class="spanClass">{{ mdl.bankAccount }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="付款事由" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.paymentDetails }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="特殊备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <span class="spanClass">{{ mdl.remark }}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="title">
          <span>评审信息</span>
        </div>
        <div class="content" style="padding: 10px 20px 15px 20px">
          <a-row>
            <a-table
              :data-source="mdl.bizReviewInfos"
              bordered
              :pagination="false"
              style="margin-top: 15px"
              v-if="mdl.types == 1"
            >
              <a-table-column key="projectCode" ellipsis="true" title="项目编号" data-index="projectCode" />
              <a-table-column key="projectUser" ellipsis="true" title="项目负责人" data-index="projectUser" />
              <a-table-column key="inspectedUnit" ellipsis="true" title="客户名称" data-index="inspectedUnit" />
              <a-table-column key="reviewDate" ellipsis="true" title="评审日期" data-index="reviewDate" />
              <a-table-column key="actualReviewDate" title="实际评审日期" data-index="actualReviewDate" width="150px">
                <template slot-scope="text, record">
                  <a-date-picker
                    valueFormat="YYYY-MM-DD"
                    allowClear
                    v-model="record.actualReviewDate"
                    placeholder="请选择"
                    :disabled="!(recoro.processDefKey == 'review' && recoro.taskDefKey == 'leader2')"
                    v-if="audit"
                  />
                  <span class="span" v-else>{{ record.actualReviewDate }}</span>
                </template>
              </a-table-column>
              <a-table-column
                key="reviewAmount"
                ellipsis="true"
                title="评审费金额(元)"
                data-index="reviewAmount"
                width="130px"
              />
              <a-table-column key="expertNum" ellipsis="true" title="专家人数" data-index="expertNum">
                <template slot-scope="text, record">
                  <a-input
                    v-model="record.expertNum"
                    type="number"
                    placeholder="请输入"
                    :disabled="!(recoro.processDefKey == 'review' && recoro.taskDefKey == 'leader2')"
                    v-if="audit"
                  ></a-input>
                  <span class="span" v-else>{{ record.expertNum }}</span>
                </template>
              </a-table-column>
              <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark" />
              <a-table-column key="delFlag" ellipsis="true" title="评审状态" data-index="delFlag">
                <template slot-scope="text, record">
                  <a
                    @click="changedel(record)"
                    v-if="audit && recoro.processDefKey == 'review' && recoro.taskDefKey == 'leader2'"
                    :style="{ color: record.delFlag == '1' ? 'red' : '#1890ff' }"
                    >{{ delFlagMap[record.delFlag] }}</a
                  >
                  <span class="span" v-else :style="{ color: record.delFlag == '1' ? 'red' : '#1890ff' }">{{
                    delFlagMap[record.delFlag]
                  }}</span>
                </template>
              </a-table-column>
            </a-table>
            <a-table
              :data-source="mdl.bizReviewInfos"
              bordered
              :pagination="false"
              style="margin-top: 15px"
              v-if="mdl.types == 2"
            >
              <a-table-column key="projectCode" ellipsis="true" title="项目编号" data-index="projectCode" />
              <a-table-column key="inspectedUnit" ellipsis="true" title="受检单位" data-index="inspectedUnit" />
              <a-table-column key="contractAmount" ellipsis="true" title="合同金额(元)" data-index="contractAmount" />
              <a-table-column key="amountDate" ellipsis="true" title="收款日期" data-index="amountDate" />
              <a-table-column key="reviewAmount" ellipsis="true" title="支付金额(元)" data-index="reviewAmount" />
              <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark" />
            </a-table>
            <a-table
              :data-source="mdl.bizReviewInfos"
              bordered
              :pagination="false"
              style="margin-top: 15px"
              v-if="mdl.types == 3"
            >
              <a-table-column key="amountDetails" ellipsis="true" title="费用明细" data-index="amountDetails" />
              <a-table-column key="reviewAmount" ellipsis="true" title="支付金额(元)" data-index="reviewAmount" />
              <a-table-column key="remark" ellipsis="true" title="备注" data-index="remark" />
            </a-table>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item label="总 金 额 " style="margin-top: 15px">
                <span class="spanClass">{{ mdl.amountTotal }}</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <div
                  class="view_path_img"
                  v-for="(item, index) in mdl.sysAttachments"
                  :key="index"
                  style="display: flex; justify-content: space-between"
                >
                  <div class="view_path_img_margin"></div>
                  <div class="view_path_img_center">
                    <img :src="item.imgUrl" @click="show_img(index, mdl.sysAttachments)" />
                  </div>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
        <div class="title" v-if="!audit && recordNumber==1">
          <span>审批记录</span>
        </div>
        <div class="content" v-if="!audit && recordNumber==1">
          <auditModel ref="auditModel"></auditModel>
        </div>
      </a-form>
    </div>
    <preview ref="preview" />
    <!-- 撤销提示 -->
    <a-modal
      v-model="is_revocation"
      :title="result == 3 ? '确认驳回此申请吗?' : '确认通过此申请吗?'"
      on-ok="handleOkReason"
    >
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 3">
          驳回
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason" v-if="result == 2">
          通过
        </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="comment" />
    </a-modal>
    <transferModal ref="transferModal" @sure="handleSure" />
  </a-modal>
</template>
<script>
import { downLoadPdf  } from '@/utils/index'
import auditModel from './audit.vue'
import { previewFileLists } from '@/utils/preview.js'

import { getReviewApply, auditTask, review_apply_info, act_task_audit, review_apply_downlodPdf } from '@/api/activiti'
import debounce from 'lodash/debounce'
import preview from '@/components/module/prview'
import { checkPermission } from '@/utils/permissions'
import transferModal from '@/views/activiti/modules/TransferModal.vue'
import Watermark from '../../../utils/watermark'
  const exportBaseUrl = process.env.VUE_APP_EXPORT_BASE_URL
export default {
  name: 'LeaveModal',
  props: {
    audit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    preview,
    transferModal,
    auditModel
  },
  data() {
    return {
      recordNumber: 0,
      is_revocation: false,
      isCancel: undefined,
      result: '',
      roles: '',
      comment: '', //驳回原因
      visible: false,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      confirmLoading: false,
      mdl: {},
      options: [],
      dateFormat: 'YYYY-MM-DD HH:mm',
      formData: {},
      form: this.$form.createForm(this),
      is_show: false,
      recoro: '',
      actualReviewDateConsumables: checkPermission('financial:servicefee:editDate'),
    }
  },
  created() {},
  methods: {
     	//导出
		downloadData() {
			downLoadPdf('/act/review_apply/downlodPdf?businessKey=' + this.recoro.businessKey,)
    },
    changedel(row) {
      var _this = this
      this.$confirm({
        title: '是否修改评审状态?',
        okText: '确定',
        cancelText: '取消',
        onOk() {
          if (row.delFlag == '0') {
            row.delFlag = '1'
            _this.updateSumbit(_this.mdl.bizReviewInfos)
          } else if (row.delFlag == '1') {
            row.delFlag = '0'
          }
          _this.$message.success('修改成功！')
          _this.$forceUpdate()
        },
        onCancel() {},
      })
    },
    handleSure() {
      this.is_show = false
      this.$emit('ok')
    },
    download() {
      review_apply_downlodPdf({
        businessKey: this.recoro.businessKey,
      }).then((res) => {
         window.open(exportBaseUrl + '/file/download?path=' + res.data)
      })
    },
    show_img(idx, imgs) {
      var row = {
        index: idx,
        imgs: imgs,
      }
      console.log(row)
      this.$refs.preview.show(row)
    },
    show(record) {
      this.recordNumber = record.recordNumber
      this.recoro = record
      this.isCancel = undefined
      this.roles = ''
      this.$store.getters.userInfo.roles.forEach((item) => {
        for (var i in item) {
          if (item['roleName'] == '部门负责人') {
            this.roles = true
          }
        }
      })
      // record 是任务 如果只是查看可以只传入一个businessKey
      if (this.audit) {
        this.formData = Object.assign({
          taskId: record.id,
          procInstId: record.procInstId,
          procName: record.processDefName,
          businessKey: record.businessKey,
          procDefKey: record.processDefKey,
          applyer: record.applyer,
        })
      }
      getReviewApply(record.businessKey).then((res) => {
        if (res.code === 200) {
         this.mdl = res.data
         console.log(this.mdl.sysAttachments,'this.mdl.sysAttachments++++++++++++++++++++++++++++++++++++++')
          previewFileLists(this.mdl.sysAttachments).then((res) => {
            this.mdl.sysAttachments = res
          })
		   const { type } = res.data
          this.mdl = Object.assign(res.data)

          this.is_show = true
          this.$nextTick(() => {
             if(!this.audit && this.recordNumber == 1) {
                 this.$refs.auditModel.show(record)
               }
            Watermark.set('安联云管家', this.$refs.sadsada)
            
          })
        }
      })
    },
    handleSubmit(result) {
      this.confirmLoading = true
      const formData = this.formData
      formData.result = result
      auditTask(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.$emit('ok')
            this.is_show = false
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    //驳回
    reject(result_) {
      if (result_ == 1) {
        this.$refs.transferModal.show({
          record: this.recoro,
        })
      } else {
        this.is_revocation = true
        this.comment = ''
        this.result = result_
      }
    },
    handleOkReason() {
      if (this.result == 3) {
        if (this.comment == '') {
          this.$message.error('请输入驳回意见！')
        } else {
          this.actTask()
        }
      } else if (this.result == 2) {
        var lis = this.mdl.bizReviewInfos
        var num = true
        var time = true
        lis.forEach((element) => {
          if (!element.expertNum && element.delFlag != '1') {
            num = false
          }
          if (!element.actualReviewDate && element.delFlag != '1') {
            time = false
          }
        })
        if (this.recoro.processDefKey == 'review' && this.recoro.taskDefKey == 'leader2') {
          if (!time) {
            this.$message.error('实际评审日期不能为空！')
            this.is_revocation = false
            return
          } else if (!num) {
            this.$message.error('专家人数不能为空！')
            this.is_revocation = false
            return
          }
          // this.updateSumbit(lis)
          this.updateSumbit2(lis)

          // var _this=this
          // this.$confirm({
          // 	title: '评审是否取消?',
          // 	okText: '是',
          // 	cancelText: '否',
          // 	onOk() {
          // 		_this.isCancel = '1'

          // 	},
          // 	onCancel() {
          // 		_this.isCancel = '0'
          // 		_this.actTask()
          // 	},
          // });
          // if(this.isCancel=='0'){
          // 	this.actTask()
          // }else{
          // 	if (this.isCancel == undefined) {
          // 		this.$message.error('请选择评审是否取消！')
          // 		this.is_revocation = false
          // 		return
          // 	} else if (!time) {
          // 		this.$message.error('实际评审日期不能为空！')
          // 		this.is_revocation = false
          // 		return
          // 	} else if (!num) {
          // 		this.$message.error('专家人数不能为空！')
          // 		this.is_revocation = false
          // 		return
          // 	}
          // 	this.updateSumbit(lis)
          // }
        } else {
          this.actTask()
        }
      }
    },
    updateSumbit: debounce(
      function (lis) {
        review_apply_info({
          bizReviewInfos: lis,
          taskId: this.recoro.id,
        }).then((res) => {
          console.log(res)
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    updateSumbit2: debounce(
      function (lis) {
        review_apply_info({
          bizReviewInfos: lis,
          taskId: this.recoro.id,
        }).then((res) => {
          if (res) {
            this.actTask()
          }
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
    actTask: debounce(
      function () {
        act_task_audit({
          taskId: this.recoro.id,
          procDefKey: this.recoro.processDefKey,
          procInstId: this.recoro.procInstId,
          procName: this.recoro.processName,
          applyer: this.recoro.applyer,
          result: this.result,
          businessKey: this.recoro.businessKey,
          comment: this.comment,
          taskDefKey: this.recoro.taskDefKey,
        }).then((res) => {
          if (res.code != 200) {
            this.$message.error(res.msg)
            return
          }
          this.$message.success('审批成功')
          this.$emit('ok')
          this.is_show = false
          this.is_revocation = false
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
  },
  watch: {
    /*
			  'selectedRows': function (selectedRows) {
			    this.needTotalList = this.needTotalList.map(item => {
			      return {
			        ...item,
			        total: selectedRows.reduce( (sum, val) => {
			          return sum + val[item.dataIndex]
			        }, 0)
			      }
			    })
			  }
			  */
  },
}
</script>
<style lang="less" scoped>
/deep/ .ant-input-disabled {
  color: #000;
  background-color: #fff;
}

/deep/ .ant-select-disabled {
  color: #000;
}

/deep/ .ant-select-selection {
  background-color: #fff;
}
</style>
